export const isSameName = (a: string, b: string) =>
  a.toLocaleLowerCase() === b.toLocaleLowerCase();

export const hasName = (items: { name: string }[], name: string) =>
  items.some((item) => isSameName(item.name, name));

export const includesText = (text: string | undefined, query: string) =>
  (text ?? '').toLocaleLowerCase().includes(query.toLocaleLowerCase());

export const splitCategoryLabel = (raw: string) => {
  const separatorIndex = raw.indexOf('/');
  if (separatorIndex === -1) return null;

  return {
    categoryName: raw.slice(0, separatorIndex).trim(),
    labelName: raw.slice(separatorIndex + 1).trim()
  };
};

export const parseCategoryLabel = (raw: string) => {
  const parts = splitCategoryLabel(raw);
  return parts?.categoryName && parts.labelName ? parts : null;
};

export const isPresent = <T>(value: T | null): value is T => value !== null;
